<div class="contentContainer chordToolContainer">
  <app-show-chords *ngIf="data.componentFlag === 'show'"></app-show-chords>
  <app-print-chords *ngIf="data.componentFlag === 'print'" (printChord)="onPrintChords($event)"></app-print-chords>
  <app-print-arpeggios *ngIf="data.componentFlag === 'arpeggios'"></app-print-arpeggios>
</div>
